import React, { MutableRefObject } from 'react';

export const onInputBlur = (
    e: React.FocusEvent,
    wrapperRef: MutableRefObject<HTMLDivElement | null>,
    inputWrapperRef: MutableRefObject<HTMLDivElement | null>,

    setOpen: (show: boolean) => void,
): boolean => {
    if (!wrapperRef.current) return false;

    const isClickOutsideContainer =
        !wrapperRef.current?.contains(e.relatedTarget as Node) ||
        inputWrapperRef.current?.contains(e.relatedTarget as Node);

    if (isClickOutsideContainer) {
        setOpen(false);
    }

    return Boolean(isClickOutsideContainer);
};

export const onWrapperBlur = (e: React.FocusEvent<HTMLDivElement>, setOpen: (show: boolean) => void) => {
    const isClickOutsideContainer = !e.currentTarget.contains(e.relatedTarget as Node);

    if (isClickOutsideContainer) {
        setOpen(false);
    }
};
